import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { ICardImageContent } from '../../../interfaces/carousel-element.interface';

@Component({
    selector: 'app-card-with-image',
    imports: [],
    templateUrl: './card-with-image.component.html',
    styleUrls: ['./card-with-image.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CardWithImageComponent implements OnInit {
  @Input() cardImageContent?: ICardImageContent;

  constructor() {}

  ngOnInit() {}
}

